import React from 'react';
import styles from './styles.module.less';

export function DisconnectScreen() {
	return <div className={styles.disconnectedScreen}>
		<div>Your device has been disconnected from the network.</div>
	</div>;
}
